<div class="acl-dialog">
  <div class="acl-dialog-header flex-between-center border-bottom-0 pb-0">
    <p class="m-0 font-bold">{{title}}</p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="closeModal()"></i>
    </span>
  </div>

  <div class="acl-dialog-body">
    <p class="font-11 font-secondary-800">{{subTitle}}
    </p>
    <div class="acl-img-wrapper">
      <img src="../../../../../assets/img/acl-bg.jpg" alt="">
    </div>
  </div>
</div>
